"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackUserIdentity = exports.getUserType = void 0;
var _users = require("../constants/users");
const getUserType = (email = '') => {
  const [isEmail, isExternal, isMCK] = email.match(`.*@(${_users.EXTERNAL_PREFIX}\.)?(${_users.MCK_DOMAIN})?.*`) || [];
  if (isExternal && isMCK) return _users.USER_TYPE.MCK_EXT;
  if (isMCK) return _users.USER_TYPE.MCK;
  if (isEmail) return _users.USER_TYPE.CLIENT;
  return 'unidentified';
};
exports.getUserType = getUserType;
const trackUserIdentity = (identifier, email, {
  heapAppId,
  isEmailTrackingEnabled
}) => {
  if (window.dtrum && isEmailTrackingEnabled) {
    window.dtrum.identifyUser(email);
  }
  if (identifier && heapAppId && window.heap && !window.heap.identity) {
    window.heap.identify(identifier);
    const userType = getUserType(email);
    window.heap.addUserProperties({
      userType,
      ...(isEmailTrackingEnabled ? {
        email
      } : {})
    });
  }
};
exports.trackUserIdentity = trackUserIdentity;